import React from "react";
import "./style.scss";

export const InputField: React.FC<InputFieldType> = ({
  label,
  type,
  id,
  placeholder,
  name,
  value,
  onChange,
  spanText,
  isError,
  disabled = false,
  children,
  min,
  onClick
}) => {
  return (
    <div className="input-group-form">
      <div className="d-flex flex-column mb-2">
        <label htmlFor={id}>{label}</label>
        {spanText && <span className="text-muted small">{spanText}</span>}
      </div>
      <div className="input-group">
        {type === "textarea" ? (
          <textarea
            className={`form-control custom-input ${
              isError ? "is-invalid" : ""
            }`}
            id={id}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        ) : (
          <input
            type={type}
            className={`form-control custom-input ${
              isError ? "is-invalid" : ""
            }`}
            id={id}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
            min={min}
            onClick={onClick}
          />
        )}
      </div>
      {isError && (
        <div className="invalid-feedback">Este campo é obrigatório</div>
      )}
      {children}
    </div>
  );
};
